<!-- 用户隐私协议 -->
<template>
    <div class="agreement">
        <div class="h3">用户协议</div>
        <div class="text">
            本《用户协议》（以下简称“协议”）是用户（个人或单一实体，以下或称“用户”）与小仓汇APP（以下简称“本产品”）使用的法律协议。
        </div>
        <div class="h5">
            1.协议内容
        </div>
        <div class="text">
            1.1主要内容：
        </div>
        <div class="text">
            第一部分重要提示；第二部分权利声明；第三部分必备条款；第四主要条款；第五部分用户守则；
        </div>
        <div class="text">
            1.2变更内容：
        </div>
        <div class="text">
            上述内容之全部，保留根据运营需要进行更改的权利所有更改、更新后的内容将在指定的异议期间结束后立即生效；
        </div>
        <div class="text">
            1.3新增内容：
        </div>
        <div class="text">
            根据运营需要定期或不定期发布的其他规则，包括但不限于论坛的论坛守则、行为规范、活动规则、定义解释等其他官方信息。
        </div>
        <div class="text">
            请注意：鉴于用户使用本产品服务之习惯，用户有义务自使用服务之日起每月自行主动对本最终用户使用许可协议之全部内容进行重新阅读，鉴于上述约定，用户因自身怠于履行该等义务的，无权以未获知上述内容而对相关条款的法律效力提出异议。
        </div>
        <div class="h5">
            2.义务
        </div>
        <br>
        <div class="text">
            2.1法定的采取合理的方式提请用户注意的义务将通过如下方式实现：
        </div>
        <div class="text">
            在本协议中以明确的足以引起用户注意的下划线、红色标记等合理方式提醒用户注意相关条款（需要强调的是，还包括但不限于用户应特别注意任何未明确标记的含有“不承担”、“免责”、“不得”“拒绝”等类似形式用语的条款），这些条款应在中国法律所允许的范围内最大程度地适用于本协议。除非用户接受本协议的全部条款，否则无权安装、复制、访问相关网站、充值、运行客户端软件或以其它方式使用本产品。
        </div>
        <div class="h5">
            3.用户的权利
        </div>
        <div class="text">
            对以上所述相关条款及本协议任何内容有异议时，用户有权利拒绝点击同意或在任何协议更新、变更、修改后30日内以致电或发送邮件形式向表示异议。
        </div>
        <div class="text">
            用户的以下任一行为将视为用户对协议完全的认可，本用户协议将立即生效并全面地对及用户产生法律约束力：
        </div>
        <div class="text">
            （1）在注册、下载、使用等任一环节点击“同意”；
        </div>
        <div class="text">
            （2）以任何可能或已经与本产品发生交互的方式使用提供的本产品产品及服务的；
        </div>
        <div class="text">
            （3）未在协议、规则等更新、变更、修改后30日内以致电或发送邮件形式向表示异议的。
        </div>
        <div class="h5">
            4.用户的认可
        </div>
        <div class="text">
            鉴于已依法履行了格式条款制订方的义务，用户以上行为将被视为且应当被视为用户已经完全注意并同意了本协议所有条款尤其是提醒用户注意的条款的合法性及有效性，用户不应当以未对格式条款以合理方式提醒用户注意或未根据用户要求尽到说明义务为理由而声称或要求法院或其它任何第三方机构确认相关条款非法或无效。
        </div>
        <br/>
        <div class="h5">
            第二部分权利声明
        </div>
        <div class="text">
            1．知识产权
        </div>
        <div class="text">
            本产品及使用说明书均受版权法保护，所有程序及图文内容非经授权方及运营商书面许可，不得以任何方式做全部或局部复制、转载或修改。本产品及包装、手册上的所有相关产品名称、商标、品牌、画面均归授权方或拥有，是属于其各自所有者的财产。
        </div>
        <div class="text">
            本产品之全部内容（包括但不仅限于任何计算机代码、用户角色、用户角色名称、用户角色资料信息、故事背景、情节语言、地名设置、任务设计、经济系统、交易系统、生产建设系统、社交系统、对抗功能、角色形象、声音效果、地图道具、动作呈现、团队系统、概念、美术作品、音效、音乐、音像、文档以及客户端和服务器软件）的知识产权归授权方所有，运营方基于授权而依法享有履行本协议之全部权利。
        </div>
        <div class="text">
            2．用户账号
        </div>
        <div class="text">
            本产品用户账号的所有权归本产品所有，用户注册成功后获得的是本产品用户账号的使用权，相应地基于该用户账号产生并储存于数据库的任何数据信息（包括但不限于账号数据信息、角色数据信息等）的所有权均属于本产品。用户在完全遵守协议的前提下，在正常使用本产品的过程中对属于其用户账号的数据信息享有协议规定的使用权。
        </div>
        <div class="text">
            3.虚拟物品
        </div>
        <div class="text">
            本产品产品和服务中的虚拟物品，包括但不限于元宝、金币、黄金、虚拟装备、虚拟道具等，享有其所有权，相应地基于该虚拟物品产生并储存于数据库的任何数据信息（包括但不限于虚拟物品数据信息、等级物品数据信息等）的所有权均属于本产品。用户在完全遵守协议的前提下，在正常使用本产品的过程中对属于其虚拟物品的数据信息享有协议规定的使用权。
        </div>
        <br>
        <div class="h5">
            第三部分必备条款
        </div>
        <div class="text">
            1.账号注册
        </div>
        <div class="text">
            1.1用户承诺以其真实身份注册成为用户，并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和必备条款约定对所提供的信息承担相应的法律责任。
        </div>
        <div class="text">
            1.2用户以其真实身份注册成为用户后，需要修改所提供的个人身份资料信息的，应当及时、有效地为其提供该项服务。
        </div>
        <div class="text">
            2.用户账号使用与保管
        </div>
        <div class="text">
            2.1根据必备条款的约定，有权审查用户注册所提供的身份信息是否真实、有效，并应积极地采取技术与管理等合理措施保障用户账号的安全、有效；用户有义务妥善保管其账号及密码，并正确、安全地使用其账号及密码。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形而给用户和他人的民事权利造成损害的，应当承担由此产生的法律责任。
        </div>
        <div class="text">
            2.2用户对登录后所持账号产生的行为依法享有权利和承担责任。
        </div>
        <div class="text">
            2.3用户发现其账号或密码被他人非法使用或有使用异常的情况的，应及时根据公布的处理方式通知，并有权通知采取措施暂停该账号的登录和使用。
        </div>
        <div class="text">
            2.4根据用户的通知采取措施暂停用户账号的登录和使用的，应当要求用户提供并核实与其注册身份信息相一致的个人有效身份信息。
        </div>
        <div class="text">
            2.4.1核实用户所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停用户账号的登录和使用。
        </div>
        <div class="text">
            2.4.2违反2.4.1款项的约定，未及时采取措施暂停用户账号的登录和使用，因此而给用户造成损失的，应当承担其相应的法律责任。
        </div>
        <div class="text">
            2.4.3用户没有提供其个人有效身份证件或者用户提供的个人有效身份证件与所注册的身份信息不一致的，有权拒绝用户上述请求。
        </div>
        <div class="text">
            2.5用户为了维护其合法权益，向提供与所注册的身份信息相一致的个人有效身份信息时，应当为用户提供账号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。
        </div>
        <div class="text">
            3.服务的中止与终止
        </div>
        <div class="text">
            3.1用户有发布违法信息、严重违背社会公德、以及其他违反法律禁止性规定的行为，应当立即终止对用户提供服务。
        </div>
        <div class="text">
            3.2用户在接受服务时实施不正当行为的，有权终止对用户提供服务。该不正当行为的具体情形应当在本协议中有明确约定或属于事先明确告知的应被终止服务的禁止性行为，否则，不得终止对用户提供服务。
        </div>
        <div class="text">
            3.3用户提供虚假注册身份信息，或实施违反本协议的行为，有权中止对用户提供全部或部分服务；采取中止措施应当通知用户并告知中止期间，中止期间应该是合理的，中止期间届满应当及时恢复对用户的服务。
        </div>
        <div class="text">
            3.4根据本条约定中止或终止对用户提供部分或全部服务的，应负举证责任。
        </div>
        <div class="text">
            4.用户信息保护
        </div>
        <div class="text">
            4.1要求用户提供与其个人身份有关的信息资料时，应当事先以明确而易见的方式向用户公开其隐私权保护政策和个人信息利用政策，并采取必要措施保护用户的个人信息资料的安全。
        </div>
        <div class="text">
            4.2未经用户许可不得向任何第三方提供、公开或共享用户注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：
        </div>
        <div class="text">
            4.2.1用户或用户监护人授权披露的；
        </div>
        <div class="text">
            4.2.2有关法律要求披露的；
        </div>
        <div class="text">
            4.2.3司法机关或行政机关基于法定程序要求提供的；
        </div>
        <div class="text">
            4.2.4为了维护自己合法权益而向用户提起诉讼或者仲裁时；
        </div>
        <div class="text">
            4.2.5应用户监护人的合法要求而提供用户个人身份信息时。
        </div>
        <div class="text">
            5.用户违约处理
        </div>
        <div class="text">
            1、如果APP发现或收到他人举报或投诉用户违反本协议约定的，本产品有权不经通知随时对相关内容，包括但不限于用户资料、聊天记录进行审查、删除，并视情节轻重对违规帐号处以包括但不限于警告、帐号封禁 、设备封禁 、功能封禁 的处罚，且通知用户处理结果。
        </div>
        <div class="text">
            2、因违反用户协议被封禁的用户，被实施功能封禁的用户会在封禁期届满后自动恢复被封禁功能。被封禁用户可向本产品相关页面提交申诉，本产品将对申诉进行审查，并自行合理判断决定是否变更处罚措施。
        </div>
        <div class="text">
            3、用户理解并同意，本产品有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此而产生的一切法律责任。
        </div>
        <div class="text">
            4、用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户应当赔偿本产品与合作公司，并使之免受损害。
        </div>
        <div class="text">
            主体信息：山东星壤网络科技有限公司
        </div>
    </div>
</template>

<script>
import { ref, reactive } from 'vue'
export default {
    setup() {
        
    }
}

</script>
<style scoped>
.agreement{
    padding: 0 15px 20px;
}
.h3{
    font-size: 20px;
    margin: 10px 0;
    text-align: center;
}
.agreement .h5{
    font-size: 18px;
}
.text{
    font-size: 16px;
    text-indent: 34px;
}
</style>